import React, { useState } from "react";

const RcNormal = () => {
  const [rcNumber, setRcNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [walletInfo, setWalletInfo] = useState(null);

  const handleSearch = async () => {
    if (!rcNumber) {
      setError("RC Number is required");
      return;
    }

    setLoading(true);
    setError("");
    setPdfUrl("");
    setWalletInfo(null);

    try {
      const res = await fetch("https://vahanapi.site/api/rc-search.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "cf251ce3bd50710adc806b0a9997b5fb0efd74589d5b41995452e39d7aec64f2"
        },
        body: JSON.stringify({
          rc_number: rcNumber
        })
      });

      const data = await res.json();

      if (!data.status) {
        setError(data.message || "RC search failed");
      } else {
        setWalletInfo({
          deducted: 40,
          balance: data.wallet_balance
        });

        // 🔥 BACKEND SE AAYA PATH → FULL URL
        setPdfUrl("https://vahanapi.site/" + data.pdf_file);
      }
    } catch (e) {
      setError("Server error, please try again");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: 20, maxWidth: 600 }}>
      <h2>🚗 RC Normal Search</h2>

      {/* RC INPUT */}
      <input
        type="text"
        placeholder="Enter RC Number"
        value={rcNumber}
        onChange={(e) => setRcNumber(e.target.value.toUpperCase())}
        style={{
          padding: 10,
          width: "100%",
          marginBottom: 10
        }}
      />

      <button
        onClick={handleSearch}
        disabled={loading}
        style={{
          padding: "10px 20px",
          width: "100%",
          cursor: loading ? "not-allowed" : "pointer"
        }}
      >
        {loading ? "Processing..." : "Search RC (₹40)"}
      </button>

      {/* ERROR */}
      {error && (
        <div style={{ color: "red", marginTop: 10 }}>
          {error}
        </div>
      )}

      {/* WALLET INFO */}
      {walletInfo && (
        <div style={{ marginTop: 15 }}>
          <p>💰 Amount Deducted: ₹{walletInfo.deducted}</p>
          <p>💼 Wallet Balance: ₹{walletInfo.balance}</p>
        </div>
      )}

      {/* PDF DOWNLOAD */}
      {pdfUrl && (
        <div style={{ marginTop: 20 }}>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "12px 20px",
              background: "#000",
              color: "#fff",
              textDecoration: "none"
            }}
          >
            📄 Download RC PDF
          </a>
        </div>
      )}
    </div>
  );
};

export default RcNormal;
